import { Button } from '@octano/global-ui';
import { useMemo } from 'react';
import { useHistory, useParams } from 'react-router';
import { Card, Col, Container, Row } from 'reactstrap';
import { PathsLayouts } from '../../../../../config/routes';
import useUserState from '../../../../../hooks/useUserState';
import { PermissionName } from '../../../../../types/Auth';
import { StudentWarningsObservationDetailsLoader } from './loaders/StudentWarningsObservationDetailsLoader';
import StudentWarningsObservationDetailsBox from './parts/StudentWarningsObservationDetailsBox';
import StudentWarningsObservationTable from './parts/StudentWarningsObservationTable';
import { StudentWarningsObservationDetailsParams } from './types';

const StudentObservationsDetails = () => {
  const params = useParams<StudentWarningsObservationDetailsParams>();
  const history = useHistory();
  const { isAuthorizedTo } = useUserState();

  const hasPermission = useMemo(
    () =>
      isAuthorizedTo([PermissionName.STUDENT_MANAGEMENT_STUDENT_FILE], true),
    [isAuthorizedTo],
  );

  return (
    <div className="mx-3">
      <Card className="p-4">
        <div className="w-100 d-flex flex-wrap justify-content-center">
          <StudentWarningsObservationDetailsLoader
            defaultQuery={{
              ...params,
            }}
            fetchImmediately
          >
            <StudentWarningsObservationDetailsBox />
            {hasPermission && (
              <Container fluid>
                <Row className="my-4">
                  <Col xs="12" className="d-flex justify-content-end">
                    <Button
                      text={`IR A EXPEDIENTE ESTUDIANTE`}
                      className="ml-2"
                      color="primary"
                      type="button"
                      icon="export"
                      size="md"
                      onClick={() => {
                        history.push(
                          `${PathsLayouts.studentFile}/update/${params.studentId}`,
                        );
                      }}
                    />
                  </Col>
                </Row>
              </Container>
            )}
            <StudentWarningsObservationTable />
          </StudentWarningsObservationDetailsLoader>
        </div>
      </Card>
    </div>
  );
};

export default StudentObservationsDetails;
